import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal } from '@yonderland/andes-react';
import { ProductPreviewLightBoxMain } from './ProductMediaLightBoxMain';
export const ProductMediaLightBox = ({ children }) => (_jsxs(Modal, { fullscreen: true, children: [_jsx(Modal.Trigger, { children: children }), _jsx(Modal.Content, { children: _jsx(ProductPreviewLightBoxMain, {}) })] }));
